import { render, staticRenderFns } from "./GetStarted.vue?vue&type=template&id=7b6b7b60"
import script from "./GetStarted.vue?vue&type=script&lang=ts"
export * from "./GetStarted.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports